import type { Transition } from 'motion/react';

/** Spring presets mirroring packages/tokens motion.spring (kept literal so tree-shaking works without the JSON). */
export const springs = {
  snappy: { type: 'spring', stiffness: 520, damping: 34, mass: 1 } satisfies Transition,
  default: { type: 'spring', stiffness: 300, damping: 28, mass: 1 } satisfies Transition,
  sheet: { type: 'spring', stiffness: 380, damping: 36, mass: 0.9 } satisfies Transition,
  bouncy: { type: 'spring', stiffness: 400, damping: 22, mass: 1 } satisfies Transition,
  gentle: { type: 'spring', stiffness: 170, damping: 26, mass: 1 } satisfies Transition,
} as const;

export const durations = { fast: 0.12, base: 0.2, slow: 0.32, sheet: 0.42 } as const;
export const easings = { standard: [0.2, 0, 0, 1], exit: [0.4, 0, 1, 1] } as const;

/** Variants */
export const fadeUp = {
  initial: { opacity: 0, y: 12 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: 8 },
} as const;

export const fade = { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } } as const;

export const listStagger = (staggerChildren = 0.04, cap = 8) => ({
  animate: { transition: { staggerChildren, delayChildren: 0.02, staggerDirection: 1 } },
  _cap: cap,
});

export const pressScale = { whileTap: { scale: 0.98 }, transition: springs.snappy } as const;
